import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface WidgetState {
  positions: number[];
}

const initialState: WidgetState = {
  positions: [1, 2, 3, 4],
};

export const widgetSlice = createSlice({
  name: "widget",
  initialState,
  reducers: {
    setPositions(state, action: PayloadAction<number[]>) {
      state.positions = action.payload;
    },
    initializePositions(state, action: PayloadAction<number[]>) {
      state.positions = action.payload;
    },
  },
});

export const { setPositions, initializePositions } = widgetSlice.actions;
export const widgetReducer = widgetSlice.reducer;
